
import { icons, FLAVOR } from "../../helpers/constants";

const pages = {
    map: {
        title: "sidebar.map",
        path: "/map",
        icon_active: icons.sidebar.device_active,
        icon_inactive: icons.sidebar.device_inactive
    },
    devices: {
        title: "sidebar.devices",
        path: "/devices",
        icon_active: icons.sidebar.device_active,
        icon_inactive: icons.sidebar.device_inactive
    },
    alarms: {
        title: "sidebar.alarms",
        path: "/events",
        icon_active: icons.sidebar.bell_active,
        icon_inactive: icons.sidebar.bell_inactive
    },
    geofence: {
        title: "sidebar.geofence",
        path: "/geofence",
        icon_active: icons.sidebar.geofence_active,
        icon_inactive: icons.sidebar.geofence_inactive
    },
    history: {
        title: "sidebar.history",
        path: "/history",
        icon_active: icons.sidebar.history_active,
        icon_inactive: icons.sidebar.history_inactive
    },
    statistics: {
        title: "sidebar.statistics",
        path: "/statistics",
        icon_active: icons.sidebar.statistics_active,
        icon_inactive: icons.sidebar.statistics_inactive
    },
    subscription: {
        title: "sidebar.subscription",
        path: "/subscriptions",
        icon_active: icons.sidebar.card_active,
        icon_inactive: icons.sidebar.card_inactive
    },
    messages: {
        title: "sidebar.messages",
        path: "/messages",
        icon_active: icons.envelope,
        icon_inactive: icons.envelope
    },
    settings: {
        title: "sidebar.settings",
        path: "/settings",
        icon_active: icons.sidebar.settings_active,
        icon_inactive: icons.sidebar.settings_inactive
    },
}

const bikeData = [
    pages.map,
    pages.devices,
    pages.alarms,
    pages.geofence,
    //pages.history,
    //process.env.REACT_APP_ASSETS !== "rawbike" && process.env.REACT_APP_ASSETS !== "livelo" && process.env.REACT_APP_ASSETS !== "seaside" ? pages.statistics : null,
    pages.subscription,
    pages.messages,
    pages.settings
].filter(Boolean);

const trackingData = [
    pages.map,
    pages.devices,
    pages.alarms,
    pages.geofence,
    // pages.history,
    pages.subscription,
    pages.messages,
    pages.settings
];

const alcoData = [
    pages.devices,
    pages.alarms,
    pages.settings
];

export const SidebarData = FLAVOR === "tracking" ? trackingData : FLAVOR === "bike" ? bikeData : FLAVOR === "alco" ? alcoData : null

